exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".postit-container {\n  width: 7in;\n  position: relative; }\n  .postit-container .postit {\n    position: relative;\n    width: 100%;\n    padding-top: 100%;\n    font-size: 4rem;\n    box-shadow: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/app/postit/postit.component.scss
// module id = ../../../../../src/app/postit/postit.component.scss
// module chunks = main